var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/table';
import { OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
var CustomersComponent = /** @class */ (function () {
    function CustomersComponent(store) {
        this.store = store;
        this._search = '';
        this.tableConfig = [
            {
                key: 'lastName',
                sortable: true,
                title: 'Surname',
                render: function (row) { return (row ? row.lastName : ''); }
            },
            {
                key: 'firstName',
                sortable: true,
                title: 'Given Name(s)',
                render: function (row) { return (row ? row.firstName : ''); }
            },
            {
                key: 'dateOfBirth',
                sortable: true,
                title: 'Date of Birth',
                render: function (row) { return (row && row.dateOfBirth ? moment(row.dateOfBirth).format('DD/MM/YYYY') : ''); }
            },
            {
                key: 'address',
                title: 'Address',
                sortable: false,
                render: function (row) {
                    var address = (row && row.address) || {};
                    return address.address1 + ", " + (address.address2 || '') + " " + address.town + " " + address.state + " " + address.postcode;
                }
            }
        ];
    }
    Object.defineProperty(CustomersComponent.prototype, "search", {
        get: function () {
            return this._search;
        },
        set: function (value) {
            this._search = value;
            this.updateSearch(this._search);
        },
        enumerable: true,
        configurable: true
    });
    CustomersComponent.prototype.ngOnInit = function () {
        this.loading$ = this.store.select(selectors.getLoadingAll(selectors.CUSTOMERS));
        this.store.dispatch(actions.Customers.UpdateFilterAction({}));
        this.store.dispatch(actions.Customers.RequestPageAction());
        this.customers = new CustomersDataSource(this.store.select(selectors.getAll(selectors.CUSTOMERS)));
        this.page$ = this.store.select(selectors.getPageination(selectors.CUSTOMERS));
        this.filter$ = this.store.select(selectors.getFilter(selectors.CUSTOMERS));
        this.admin$ = this.store.select(selectors.auth.isAdmin);
    };
    CustomersComponent.prototype.paginate = function (event) {
        this.store.dispatch(actions.Customers.PageChangeAction(event));
    };
    CustomersComponent.prototype.updateSearch = function (search) {
        if (search.length > 0) {
            this.store.dispatch(actions.Customers.UpdateFilterAction({
                where: {
                    or: [{ firstName: { ilike: search + "%" } }, { lastName: { ilike: search + "%" } }]
                }
            }));
        }
        else {
            this.store.dispatch(actions.Customers.UpdateFilterAction({}));
        }
    };
    CustomersComponent.prototype.sort = function (event) {
        if (event.direction) {
            this.store.dispatch(actions.Customers.UpdateFilterAction({
                order: event.active + " " + event.direction.toUpperCase()
            }));
        }
    };
    return CustomersComponent;
}());
export { CustomersComponent };
var CustomersDataSource = /** @class */ (function (_super) {
    __extends(CustomersDataSource, _super);
    function CustomersDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    CustomersDataSource.prototype.connect = function () {
        return this.data;
    };
    CustomersDataSource.prototype.disconnect = function () {
        // lint
    };
    return CustomersDataSource;
}(DataSource));
export { CustomersDataSource };
